import { render, staticRenderFns } from "./ScalingBar.vue?vue&type=template&id=4e8ede57&scoped=true&lang=pug&"
import script from "./ScalingBar.vue?vue&type=script&lang=js&"
export * from "./ScalingBar.vue?vue&type=script&lang=js&"
import style0 from "./ScalingBar.vue?vue&type=style&index=0&id=4e8ede57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8ede57",
  null
  
)

export default component.exports